module.exports = __webpack_public_path__ + "static/media/gryphon-house-appliances.be3ac75f.jpg";